import { render, staticRenderFns } from "./select-institution.vue?vue&type=template&id=45e5610a&lang=pug&"
import script from "./select-institution.vue?vue&type=script&lang=ts&"
export * from "./select-institution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports